import React from 'react';
export class IconButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleMouseEnter = () => {
            this.setState({ hover: true });
        };
        this.handleMouseLeave = () => {
            this.setState({ hover: false });
        };
        this.render = () => {
            const colorStyle = !this.props.disabled && !this.props.iconHover
                ? 'hover:text-white hover:bg-primary-800 transition-colors duration-150'
                : '';
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { disabled: this.props.disabled, onClick: this.props.onClick, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, className: `${this.props.className} inline-flex items-center px-2 py-2 text-sm font-semibold rounded text-base-400 ${colorStyle}`, style: this.props.style }, this.state.hover && this.props.iconHover ? this.props.iconHover : this.props.icon)));
        };
        this.state = { hover: false };
    }
}
